var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root" },
    [
      _vm.shouldShowProfit
        ? _c(
            "div",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12", md: "5" } }, [
                    _c("table", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$ct("selected-unit-buy-price"))),
                        ]),
                        _c(
                          "td",
                          { style: { display: "flex" } },
                          [
                            _c("w-spacer"),
                            _vm.selectedRow
                              ? _c("w-input-number", {
                                  staticClass: "unit-buy-price",
                                  style: { textAlign: "right" },
                                  model: {
                                    value: _vm.selectedRow.UnitBuyPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedRow,
                                        "UnitBuyPrice",
                                        $$v
                                      )
                                    },
                                    expression: "selectedRow.UnitBuyPrice",
                                  },
                                })
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("humanFloat")(
                                        _vm.selectedUnitBuyPrice,
                                        _vm.decimalSettings.Buy
                                      )
                                    )
                                  ),
                                ]),
                          ],
                          1
                        ),
                      ]),
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.$ct("selected-profit")))]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("humanFloat")(
                                _vm.selectedProfit,
                                _vm.decimalSettings.Buy
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("tr", { staticClass: "total" }, [
                        _c("th", [_vm._v(_vm._s(_vm.$ct("total-profit")))]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("humanFloat")(
                                _vm.totalProfit,
                                _vm.decimalSettings.Unit
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("w-col", { attrs: { xs: "12", md: "2" } }),
                  _c("w-col", { attrs: { xs: "12", md: "5" } }, [
                    _c("table", [
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.$ct("netto-total")))]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("humanFloat")(
                                _vm.totalNetto,
                                _vm.decimalSettings.Unit
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.$ct("vat-total")))]),
                        _c("td", [
                          _vm._v(_vm._s(_vm._f("humanFloat")(_vm.vat, 2))),
                        ]),
                      ]),
                      _vm.totalLeeggoed != 0
                        ? _c("tr", [
                            _c("th", [
                              _vm._v(_vm._s(_vm.$ct("leeggoed-total"))),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("humanFloat")(
                                    _vm.totalLeeggoed,
                                    _vm.decimalSettings.Bruto
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c("tr", { staticClass: "total" }, [
                        _c("th", [_vm._v(_vm._s(_vm.$ct("bruto-total")))]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("humanFloat")(
                                _vm.total,
                                _vm.decimalSettings.Bruto
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.shouldShowProfit
        ? _c(
            "w-row",
            { staticClass: "shortTotals" },
            [
              _c("w-col", { attrs: { xs: "12", sm: "1" } }),
              _c("w-col", { attrs: { xs: "12", sm: "3" } }, [
                _c("label", [_vm._v(_vm._s(_vm.$ct("netto-total")))]),
                _vm._v(
                  " " + _vm._s(_vm._f("humanFloat")(_vm.totalNetto)) + " "
                ),
              ]),
              _c("w-col", { attrs: { xs: "12", sm: "4" } }, [
                _c("label", [_vm._v(_vm._s(_vm.$ct("vat-total")))]),
                _vm._v(" " + _vm._s(_vm._f("humanFloat")(_vm.vat)) + " "),
              ]),
              _c("w-col", { attrs: { xs: "12", sm: "4" } }, [
                _c("label", [_vm._v(_vm._s(_vm.$ct("bruto-total")))]),
                _vm._v(" " + _vm._s(_vm._f("humanFloat")(_vm.total)) + " "),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }